import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CLINICS } from '../../constant';

export const getDropdownSettingsApi = createAsyncThunk(
  'dropdownSettings/get',
  async (_, { rejectWithValue }) => {
    try {
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
      };

      const res = await fetch(CLINICS.DROPDOWN_SETTINGS_URL, requestOptions);

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        return rejectWithValue(errorData.msg || 'Failed to fetch dropdown settings');
      }

      const data = await res.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
